const removeHttp = (url) => url.replace(/^https?:\/\//, '');

export default removeHttp;
